import { Anchor } from '@mantine/core';

interface TopBarLinkProps {
  title: string;
  href: string;
}

const TopBarLink = ({ title, href }: TopBarLinkProps) => (
  <Anchor
    key={title}
    href={href}
    target="_blank"
    rel="noreferrer"
    title={title}
    color="dimmed"
    underline={false}
    sx={(theme) => ({
      color: theme.colors.brandWhite,
      margin: `0 ${theme.other.spacing(1.5)}`,
      '&:hover': {
        color: theme.colors.grayLightest,
      },
    })}
  >
    {title}
  </Anchor>
);

export default TopBarLink;
